import { api } from "..";

export interface DeleteBettingRulesResponse {
  success: boolean;
  deleteCount: number;
}

export interface DeleteBettingRulesParams {
  targetUsername?: string;
  asTargetOwn?: boolean;
}

export async function deleteBettingRules(
  params: DeleteBettingRulesParams
): Promise<DeleteBettingRulesResponse> {
  const res = await api.client.delete("/betting-rules", {
    params,
  });
  return res.data;
}